// const log = global.log.getLogger("f_mtac.Room");

const SPACE_ID_LENGTH = 2, DESKTOP_ID_LENGTH = 1, SECRET_ID_LENGTH = 4;

const c0 = "0".charCodeAt(0), c9 = "9".charCodeAt(0);
const ca = "a".charCodeAt(0), cz = "z".charCodeAt(0);
const desktop_index_to_desktop_id = (desktop_index) => {
    if (desktop_index >= 0 && desktop_index <= (c9 - c0)) {
        return String.fromCharCode(c0 + desktop_index);
    } else if (desktop_index > (c9 - c0) && desktop_index <= (cz - ca)) {
        return String.fromCharCode(ca + desktop_index);
    } else {
        throw `Desktop index out of range ${desktop_index}`;
    }
};
const desktop_id_to_desktop_index = (desktop_id) => {
    let desktop_char_code = desktop_id.charCodeAt(0);
    if (desktop_char_code >= c0 && desktop_char_code <= c9) {
        return desktop_char_code - c0;
    } else if (desktop_char_code >= ca && desktop_char_code <= cz) {
        return (c9 - c0) + desktop_char_code - ca;
    } else {
        throw `Desktop id out of range ${desktop_id}`;
    }
};

let Room = function(room_id) {
    if (room_id.length === SPACE_ID_LENGTH + SECRET_ID_LENGTH) {
        room_id = room_id.slice(0, SPACE_ID_LENGTH) + "_" + room_id.slice(SPACE_ID_LENGTH);
    }
    if (room_id.length != SPACE_ID_LENGTH + DESKTOP_ID_LENGTH + SECRET_ID_LENGTH) {
        throw `Room ID shall be of length ${SPACE_ID_LENGTH + DESKTOP_ID_LENGTH + SECRET_ID_LENGTH}`;
    }
    this.toString = () => room_id;
    Object.defineProperty(this, "space", {
        get: () => room_id.slice(0, SPACE_ID_LENGTH),
        set: (space_id) => {
            if (space_id.length != SPACE_ID_LENGTH) {
                throw `Space ID shall be of length ${SPACE_ID_LENGTH}`;
            }
            room_id = space_id + room_id.slice(SPACE_ID_LENGTH);
        }
    });

    Object.defineProperty(this, "desktop_index", {
        get: () => {
            var desktop_id = this.desktop;
            if (desktop_id === null) {
                return null;
            }
            return desktop_id_to_desktop_index(desktop_id);
        },
        set: (desktop_index) => {
            var desktop_id;
            if (desktop_index === null) {
                desktop_id = "_";
            } else {
                desktop_id = desktop_index_to_desktop_id(desktop_index);
            }
            room_id = room_id.slice(0, SPACE_ID_LENGTH) + desktop_id + room_id.slice(SPACE_ID_LENGTH + DESKTOP_ID_LENGTH);
        }
    });
    Object.defineProperty(this, "desktop", {
        get: () => {
            var desktop_id = room_id.slice(SPACE_ID_LENGTH, SPACE_ID_LENGTH + DESKTOP_ID_LENGTH);
            if (desktop_id === "_") {
                return null;
            }
            return desktop_id;
        },
        set: (desktop_id) => {
            if (desktop_id === null) {
                desktop_id = "_";
            } else if (typeof desktop_id === "number") {
                desktop_id = desktop_index_to_desktop_id(desktop_id);
            }
            if (desktop_id.length != DESKTOP_ID_LENGTH) {
                throw `Desktop ID length shall be ${DESKTOP_ID_LENGTH}`;
            }
            room_id = room_id.slice(0, SPACE_ID_LENGTH) + desktop_id + room_id.slice(SPACE_ID_LENGTH + DESKTOP_ID_LENGTH);
        }
    });
    Object.defineProperty(this, "secret", {
        get: () => room_id.slice(SPACE_ID_LENGTH + DESKTOP_ID_LENGTH),
        set: (secret_id) => {
            if (secret_id.length != SECRET_ID_LENGTH) {
                throw `Secret ID length shall be ${SECRET_ID_LENGTH}`;
            }
            room_id = room_id.slice(0, SPACE_ID_LENGTH + DESKTOP_ID_LENGTH) + secret_id;
        }
    });
    Object.defineProperty(this, "room_id", {
        set: () => {},
        get: () => room_id
    });
    Object.defineProperty(this, "short_id", {
        set: () => {},
        get: () => this.space+this.secret
    });
    this.duplicate = () => new Room(room_id);
};
Room.desktop_index_to_desktop_id = desktop_index_to_desktop_id;
Room.desktop_id_to_desktop_index = desktop_id_to_desktop_index;
export default Room;

